<template>
	<!-- 表格项 -->
	<div class="treatment-schedule-item" :style="{ backgroundColor: currentItem.backgroundColor, color: currentItem.color, borderColor: currentItem.color }">
		<span>{{ currentItem[labelName] }}</span>
		<slot name="after"></slot>
	</div>
</template>

<script>
import { scheduleTimeOptions } from '@/hooks/schedule'
export default {
	name: 'treatment-schedule-item',
	props: {
		value: {
			type: String,
			default: ''
		},
		labelName: {
			type: String,
			default: 'short'
		}
	},
	data() {
		return {

		}
	},
	computed: {
		currentItem() {
			return (scheduleTimeOptions.find((row) => row.code == this.value) || {})
		}
	},
	mounted() {

	},
	methods: {
		
	}
}
</script>

<style scoped lang="scss">
.treatment-schedule-item {
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	user-select: none;
}
</style>
